module.exports = __webpack_public_path__ + "img/mobile-rental-image-01.500d046a.png";